// extracted by mini-css-extract-plugin
export default {"search-box":"bs_Qt","search-box__input":"bs_Qv form-control","search-box__icon":"bs_Qw ml-2"};